import React from 'react';
import { solutionData } from '@/data/mock';
import { ClipboardCheck, Map, ListChecks, ArrowRight } from 'lucide-react';

const iconMap = {
  ClipboardCheck,
  Map,
  ListChecks,
};

export const SolutionSection = () => {
  return (
    <section className="relative py-24 bg-slate-950">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-cyan-500/5 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-cyan-500/10 text-cyan-400 text-sm font-medium rounded-full mb-4">
            The Solution
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {solutionData.title}
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            {solutionData.subtitle}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {solutionData.steps.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={index} className="relative">
                <div className="p-8 bg-gradient-to-b from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-2xl h-full">
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-indigo-500/20 flex items-center justify-center mb-6">
                    <Icon size={28} className="text-cyan-400" />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-3">{step.title}</h3>
                  <p className="text-slate-400">{step.description}</p>
                </div>
                
                {/* Arrow connector */}
                {index < solutionData.steps.length - 1 && (
                  <div className="hidden md:flex absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <ArrowRight size={24} className="text-slate-600" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
